import React, { Component } from "react";
import { Row, Col, Button, FormGroup } from "reactstrap";
import {
  getChildCategoryListRequest,
  addCategoryRequest,
  updateCategoryByCategoryIdRequest,
  getCategoryListForSubCategoryRequest,
} from "store/actions";
import { Formik, Form, Field } from "formik";
import Select from "react-select";
import { fileCompress, filePreview } from "helpers/generalUtils";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import { compose } from "redux";
import { toastrMessage } from "helpers/messageHelper";
import { jsonToFormData } from "helpers/axiosRequestData";

import {
  makeCategorySelectField,
  selectSortedCategories,
} from "store/Masters/Category/selector";

// import constants
import { SUBMIT, UPDATE, SUCCESS, DANGER } from "constants/commonConstants";
import { IMAGE_FILE_TYPE } from "helpers/constants";

import { createStructuredSelector } from "reselect";

import CustomisedModal from "components/Application/CustomisedModal";

// import custom validator
import {
  lessThanFileSizeValidator,
  fileTypeValidator,
} from "helpers/customValidator";

class SubCategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operationType: SUBMIT,
      subCategoryData: subCategoryDataInitialState(),
      imagePreview: null,
    };

    this.validator = new SimpleReactValidator({
      validators: Object.assign(
        lessThanFileSizeValidator(),
        fileTypeValidator()
      ),
    });
  }

  componentDidMount() {
    this.props.getCategoryListForSubCategoryRequest();
  }

  resetForm = (closeModal) => {
    this.setState({
      subCategoryData: subCategoryDataInitialState(),
      imagePreview: null,
      operationType: SUBMIT,
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.subCategoryApiResponse &&
      this.props.subCategoryApiResponse !== nextprops.subCategoryApiResponse
    ) {
      if (nextprops.subCategoryApiResponse.isSuccessResponse) {
        this.props.getChildCategoryListRequest();
        toastrMessage(
          nextprops.subCategoryApiResponse.responseMessage,
          SUCCESS
        );
        this.resetForm(true);
      } else if (!nextprops.subCategoryApiResponse.isSuccessResponse) {
        toastrMessage(nextprops.subCategoryApiResponse.responseMessage, DANGER);
      }
    }
    if (
      nextprops.subCategoryRecord &&
      this.props.subCategoryRecord !== nextprops.subCategoryRecord
    ) {
      if (nextprops.subCategoryRecord.categoryId) {
        this.setState({
          subCategoryData: nextprops.subCategoryRecord,
          operationType: UPDATE,
          imagePreview: nextprops.subCategoryRecord.categoryImageUrl,
        });
      } else {
        this.resetForm(false);
      }
    }
  }

  handleFilePreview = async (event, setFieldValue) => {
    // check if any one file is selected by user
    if (event.target.files.length > 0) {
      let file = event.target.files[0];

      await setFieldValue("categoryImage", file);

      if (this.validator.fieldValid("categoryImage")) {
        try {
          let response = await fileCompress(file);
          await setFieldValue("categoryImage", response);
          response = await filePreview(response);

          this.setState({ imagePreview: response });
        } catch (error) {
          this.setState({ imagePreview: null });
          setFieldValue("categoryImage", "");
        }
      } else {
        this.setState({ imagePreview: null });
      }
    }
  };

  formSubmit = (val) => {
    const values = {
      ...val
    }
    if (this.validator.allValid()) {
      // values.categoryImage = ""
      this.setState({ subCategoryData: values });
      if (this.state.operationType === UPDATE) {
        values.IsImageChanged = values.categoryImage ? true : false;
        const data = jsonToFormData(values);
        this.props.updateCategoryByCategoryIdRequest(values.categoryId, data);
      } else {
        values.categoryType = 2;
        const data = jsonToFormData(values);
        this.props.addCategoryRequest(data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="Sub Category"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.subCategoryData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row className="form-group">
                  <Col sm="4" lg="3">
                    <label>Select Category</label>
                  </Col>
                  <Col sm="8" lg="5">
                    <Field
                      component={Select}
                      name="parentId"
                      options={this.props.sortedCategoryList}
                      onChange={(opt, e) => {
                        setFieldValue("parentId", opt.value);
                      }}
                      value={this.props.sortedCategoryList.filter(
                        (option) => option.value === values.parentId
                      )}
                    ></Field>
                    {this.validator.message(
                      "parentId",
                      values.parentId,
                      "required"
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Sub Category Name</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="categoryName"
                          type="text"
                          className="form-control"
                          autoFocus
                        ></Field>
                        {this.validator.message(
                          "categoryName",
                          values.categoryName,
                          "required"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Sub Category Sequence</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <Field
                          name="categorySeq"
                          type="number"
                          className="form-control"
                        ></Field>
                        {this.validator.message(
                          "Sub Category Sequence",
                          values.categorySeq,
                          "required|numeric|min:1,num"
                        )}
                      </Col>
                    </Row>

                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Sub Category Image</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            name="categoryImage"
                            accept="image/*"
                            onClick={(e) => (e.target.value = null)}
                            id="customFile"
                            onChange={(event) =>
                              this.handleFilePreview(event, setFieldValue)
                            }
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="customFile"
                          >
                            {values.categoryImage
                              ? values.categoryImage.name
                              : "Choose file"}
                          </label>
                        </div>
                        {this.validator.message(
                          "categoryImage",
                          values.categoryImage,
                          (this.state.operationType === SUBMIT
                            ? "required|"
                            : "") +
                            `lessThanFileSize:5242880|fileType:${IMAGE_FILE_TYPE}`
                        )}
                      </Col>
                    </Row>

                    {this.state.imagePreview && (
                      <Row className="form-group">
                        <Col sm="4" lg="3"></Col>
                        <Col sm="8" lg="5">
                          <img
                            className="img-thumbnail"
                            alt={values.categoryName}
                            width="200"
                            src={this.state.imagePreview}
                            data-holder-rendered="true"
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {this.state.operationType}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  subCategoryApiResponse: makeCategorySelectField("categoryApiResponse"),
  sortedCategoryList: selectSortedCategories(),
});

const withConnect = connect(mapStatetoProps, {
  getChildCategoryListRequest,
  addCategoryRequest,
  updateCategoryByCategoryIdRequest,
  getCategoryListForSubCategoryRequest,
});

export default compose(withConnect, withRouter)(SubCategoryForm);
//export default withRouter(withConnect)(Index);

function subCategoryDataInitialState() {
  return {
    parentId: "",
    categoryName: "",
    categoryImage: "",
    categorySeq: "",
  };
}
